export default __webpack_public_path__ + "static/draft-react-9180f328bee26a05f1006dae66ef2a73.png";